import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import {IConfigFieldDefinition} from '../../services/configurations-areas/fields-definitions/config-field-definition-base';
import {observer} from 'mobx-react';
import {splitArrayToChunks} from '../../../utils/array-helper';
import {FieldsBatchComponent} from './fields-batch.component';
import Grid from '@material-ui/core/Grid';


export interface ConfigurationsAreaEditorComponentProps {
    title: string;
    batchSize: number;
    fields: IConfigFieldDefinition[];
}


@observer
export class ConfigurationsAreaEditorComponent extends LauncherComponentBase<ConfigurationsAreaEditorComponentProps> {
    private _renderFieldsBatch(batch: IConfigFieldDefinition[]) {
        let key = batch.map(field => field.configurationKey).join('');
        return <FieldsBatchComponent key={key} fields={batch}/>
    }
    render() {
        let fieldsBatches: Array<IConfigFieldDefinition[]>;
        if(this.services.deviceTypeDetection.isMobile) {
            fieldsBatches = [this.props.fields];
        } else {
            fieldsBatches = splitArrayToChunks(this.props.fields, this.props.batchSize);
        }

        return (
            <div>
                <ExpansionPanel defaultExpanded={!this.services.deviceTypeDetection.isMobile}>
                    <ExpansionPanelSummary>
                        <Typography variant="button">{this.props.title}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={0}>
                            {fieldsBatches.map(batch => this._renderFieldsBatch(batch))}
                        </Grid>

                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        );
    }
}